module.exports = __webpack_public_path__ + "static/media/list.fec6a72f.svg";